(function() {
  var root = document.getElementById('gallery-wall-builder');
  if (!root) return;
 
  var PRODUCTS_URL = root.dataset.productsUrl;
  var stage = document.getElementById('gwb-stage');
 
  var stageGuides = document.getElementById('gwb-stage-guides');
  var stageOverlay = document.getElementById('gwb-stage-overlay');
  var slotControls = document.getElementById('gwb-slot-controls');
  var summaryText = document.getElementById('gwb-summary-text');
  var totalPriceEl = document.getElementById('gwb-total-price');
  var messageEl = document.getElementById('gwb-message');
  var addBtn = document.getElementById('gwb-add-to-cart');
  var modal = document.getElementById('gwb-modal');
  var modalStatus = document.getElementById('gwb-modal-status');
  var productGrid = document.getElementById('gwb-product-grid');
  var searchInput = document.getElementById('gwb-product-search');
  var loadMoreBtn = document.getElementById('gwb-load-more');
  var modalSlotLabel = document.getElementById('gwb-modal-slot-label');
  var photoInput = document.getElementById('gwb-photo-input');
  var photoTrigger = document.getElementById('gwb-photo-trigger');
  var photoRemove = document.getElementById('gwb-photo-remove');
  var customPhotoLayer = document.getElementById('gwb-custom-photo-layer');
  var customPhotoImage = document.getElementById('gwb-custom-photo-image');
  var photoPositionControls = document.getElementById('gwb-photo-position-controls');
  var photoHorizontal = document.getElementById('gwb-photo-horizontal');
  var photoVertical = document.getElementById('gwb-photo-vertical');
  var resetPresetBtn = document.getElementById('gwb-reset-preset');
  var centerCompositionBtn = document.getElementById('gwb-center-composition');
  var summaryDetailsEl = document.getElementById('gwb-summary-details');
  var mobileSlotSwitchStage = document.getElementById('gwb-mobile-slot-switch-stage');
  var mobileDrawer = document.getElementById('gwb-mobile-drawer');
  var mobileDrawerContent = document.getElementById('gwb-mobile-drawer-content');
  var mobileDrawerTitle = document.getElementById('gwb-mobile-drawer-title');
  var mobileDrawerClose = document.getElementById('gwb-mobile-drawer-close');
 
  var FORMAT_LABELS = ['30×40cm', '50×70cm', 'A2', 'A1', '61×91cm', '70×100cm'];
  var WALL_WIDTH_CM = 300;
  var gwbData = {};
  try { gwbData = JSON.parse((document.getElementById('gwb-data') || {}).textContent || '{}'); } catch (e) {}
  var gwbDecors = gwbData.decors || {};
  var DECORS = {
    salon: { url: gwbDecors.salon || '', ratio: 1600 / 1100 },
    chambre: { url: gwbDecors.chambre || '', ratio: 1600 / 1100 },
    bureau: { url: gwbDecors.bureau || '', ratio: 1600 / 1100 },
    entree: { url: gwbDecors.entree || '', ratio: 1600 / 1100 }
  };
 
  var state = {
    activeScene: 'salon',
    count: 3,
    activeSlotId: 1,
    stageRatio: 1600 / 1100,
    slots: [],
    products: [],
    filteredProducts: [],
    visibleCount: 20,
    search: '',
    customPhoto: {
      enabled: false,
      src: '',
      x: 0,
      y: 0,
      dragging: false,
      startX: 0,
      startY: 0,
      baseX: 0,
      baseY: 0,
      naturalWidth: 0,
      naturalHeight: 0,
      displayWidth: 0,
      displayHeight: 0
    },
    drag: null,
    pointer: null,
    suppressClick: false,
    activePreset: 'symetrique',
    spacingMode: 'equilibre',
    snapGuides: { x: null, y: null },
    mobileFocusSlotId: null,
    mobileDrawerOpen: false
  };
 
  var STORAGE_KEY = 'cassili_gallery_wall_builder_v4';
  var restoredState = null;
 
  function escapeHtml(str) {
    return String(str || '').replace(/[&<>'"]/g, function(m) {
      return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' })[m];
    });
  }
 
  function normalizeProducts(items) {
    return (items || []).map(function(product) {
      var variants = (product.variants || []).map(function(variant) {
        return {
          id: Number(variant.id),
          title: variant.title || '',
          available: variant.available !== false,
          size: variant.option1 || '',
          finish: variant.option2 || '',
          price: Number(variant.price || 0)
        };
      }).filter(function(variant) { return variant.available; });
 
      var available = product.available !== false && variants.length > 0;
      var image = product.images && product.images.length ? (product.images[0].src || product.images[0]) : '';
 
      return {
        id: product.id,
        title: product.title || '',
        image: image || '',
        images: (product.images || []).map(function(img) { return img && (img.src || img) ? (img.src || img) : ''; }).filter(Boolean),
        available: available,
        variants: variants,
        sizes: Array.from(new Set(variants.map(function(v) { return v.size; }).filter(Boolean))),
        finishes: Array.from(new Set(variants.map(function(v) { return v.finish; }).filter(Boolean)))
      };
    }).filter(function(product) { return product.available; });
  }
 
  function getDisplayFormatLabel(format) {
    var labels = {
      '30×40cm': '30×40 cm',
      '30 × 40 cm': '30×40 cm',
      '50×70cm': '50×70 cm',
      '50 × 70 cm': '50×70 cm',
      'A2': 'A2 (42×59 cm)',
      'A2 (42×59 cm)': 'A2 (42×59 cm)',
      'A2 (42×59.4 cm)': 'A2 (42×59 cm)',
      'A1': 'A1 (59×84 cm)',
      'A1 (59×84 cm)': 'A1 (59×84 cm)',
      'A1 (59.4×84.1 cm)': 'A1 (59×84 cm)'
    };
    return labels[format] || format;
  }
 
  function getRealSizeBadge(format) {
    var labels = {
      '30×40cm': '30×40 cm',
      '30 × 40 cm': '30×40 cm',
      '50×70cm': '50×70 cm',
      '50 × 70 cm': '50×70 cm',
      'A2': '42×59 cm',
      'A2 (42×59 cm)': '42×59 cm',
      'A2 (42×59.4 cm)': '42×59 cm',
      'A1': '59×84 cm',
      'A1 (59×84 cm)': '59×84 cm'
    };
    return labels[format] || format;
  }
 
  function normalizeFormatToken(format) {
    if (!format) return '';
    return String(format).toLowerCase()
      .replace(/\s/g, '')
      .replace(/×/g, 'x')
      .replace(/cm/g, '')
      .replace(/\(/g, '')
      .replace(/\)/g, '');
  }
 
  function parseFormatDimensions(format) {
    if (!format) return null;
    var f = normalizeFormatToken(format);
 
    // Formats ISO : le libelle ne porte pas toujours les dimensions
    if (f.indexOf('a2') !== -1) return { width: 42, height: 59.4 };
    if (f.indexOf('a1') !== -1) return { width: 59.4, height: 84.1 };
 
    var m = f.match(/(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)/);
    if (!m) return null;
 
    var w = parseFloat(m[1].replace(',', '.'));
    var h = parseFloat(m[2].replace(',', '.'));
    if (!w || !h) return null;
 
    return { width: w, height: h };
  }
 
  function getAspectRatio(format) {
    var dims = parseFormatDimensions(format);
    if (dims) return dims.height / dims.width;
 
    console.warn('Ratio non reconnu:', format);
    return 4 / 3;
  }
 
  function getWidthPercentForFormat(format) {
    var dims = parseFormatDimensions(format);
    if (dims) return Math.round((dims.width / WALL_WIDTH_CM) * 1000) / 10;
 
    console.warn('Format non reconnu:', format);
    return 10;
  }
 
  function getHeightPercent(slot) {
    var ratio = getAspectRatio(slot.format);
    var stageRect = stage.getBoundingClientRect();
    var stageWidth = Math.max(stageRect.width, 1);
    var stageHeight = Math.max(stageRect.height, 1);
    return slot.widthPct * ratio * (stageWidth / stageHeight);
  }
 
  function clampSlotPercent(slot) {
    slot.widthPct = Math.max(8, Math.min(slot.widthPct, 34));
    var heightPct = getHeightPercent(slot);
    slot.xPct = Math.max(0, Math.min(slot.xPct, 100 - slot.widthPct));
    slot.yPct = Math.max(0, Math.min(slot.yPct, 100 - heightPct));
  }
 
  function computeDefaultSlots(count) {
    var positionsByCount = {
      1: [{x:42.5,y:31}],
      2: [{x:26,y:31},{x:54,y:31}],
      3: [{x:16,y:33},{x:40,y:24},{x:64,y:33}],
      4: [{x:19,y:16},{x:49,y:16},{x:19,y:56},{x:49,y:56}],
      5: [{x:10,y:14},{x:38,y:8},{x:66,y:14},{x:24,y:55},{x:52,y:55}],
      6: [{x:8,y:12},{x:38,y:8},{x:68,y:12},{x:8,y:54},{x:38,y:50},{x:68,y:54}]
    };
    var points = positionsByCount[count] || positionsByCount[3];
    return points.map(function(point, index) {
      var slot = {
        id: index + 1,
        xPct: point.x,
        yPct: point.y,
        widthPct: getWidthPercentForFormat('30×40cm'),
        format: '30×40cm',
        finish: 'Poster',
        product: null,
        image: '',
        variantId: null
      };
      clampSlotPercent(slot);
      return slot;
    });
  }
 
  function preserveSlots(nextCount) {
    var next = [];
    for (var i = 0; i < nextCount; i++) {
      if (state.slots[i]) next.push(Object.assign({}, state.slots[i], { id: i + 1 }));
    }
    if (next.length < nextCount) {
      var defaults = computeDefaultSlots(nextCount);
      for (var j = next.length; j < nextCount; j++) next.push(defaults[j]);
    }
    state.slots = next;
    if (state.activeSlotId > nextCount) state.activeSlotId = 1;
  }
 
  function getSlotById(id) {
    var nid = Number(id);
    return state.slots.find(function(slot) { return slot.id === nid; });
  }
 
  function ensureVariant(slot) {
    if (!slot.product) { slot.variantId = null; return; }
    var matching = slot.product.variants.filter(function(variant) {
      return variant.size === slot.format && variant.finish === slot.finish && variant.available;
    });
    if (matching[0]) {
      slot.variantId = matching[0].id;
      if (messageEl && messageEl.textContent === 'Format non disponible pour cette finition') {
        messageEl.textContent = '';
      }
      return;
    }
 
    slot.variantId = null;
 
    var firstForSize = slot.product.variants.find(function(variant) {
      return variant.size === slot.format && variant.available;
    });
 
    if (firstForSize) {
      slot.finish = firstForSize.finish || slot.finish;
      slot.variantId = firstForSize.id;
      if (messageEl && messageEl.textContent === 'Format non disponible pour cette finition') {
        messageEl.textContent = '';
      }
      return;
    }
 
    if (messageEl) {
      messageEl.textContent = 'Format non disponible pour cette finition';
    }
  }
 
  function getVariantPrice(slot) {
    if (!slot || !slot.variantId || !slot.product) return 0;
    var variant = slot.product.variants.find(function(v) { return Number(v.id) === Number(slot.variantId); });
    return variant ? Number(variant.price || 0) : 0;
  }
 
  function formatMoney(value) {
    var amount = Number(value || 0);
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
  }
 
  function getSlotImageForFinish(product, finish) {
    if (!product) return '';
    var images = Array.isArray(product.images) ? product.images : [];
    function getImageAt(index) {
      var image = images[index];
      return image ? (image.src || image) : '';
    }
    if (finish === 'Encadrée') {
      return (product.images && product.images[7]) ? (product.images[7].src || product.images[7]) : ((product.images && product.images[0]) ? (product.images[0].src || product.images[0]) : (product.image || ''));
    }
    return (product.images && product.images[5]) ? (product.images[5].src || product.images[5]) : ((product.images && product.images[0]) ? (product.images[0].src || product.images[0]) : (product.image || ''));
  }
 
  // Single source of truth, aligned on the CSS breakpoint (@media max-width:739px).
  var gwbMobileMQ = window.matchMedia('(max-width: 739px)');
  function isMobileMode() {
    return gwbMobileMQ.matches;
  }
 
  // When the mobile drawer opens, keep the composition visible above it:
  // shrink the stage (CSS) and scroll it back into view.
  var gwbDrawerWasOpen = false;
  var gwbReduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function gwbScrollStageIntoView() {
    var wrap = (stage && stage.closest) ? stage.closest('.gwb__stage-wrap') : null;
    if (wrap && wrap.scrollIntoView) {
      try { wrap.scrollIntoView({ behavior: gwbReduceMotion ? 'auto' : 'smooth', block: 'start' }); } catch (e) { wrap.scrollIntoView(); }
    }
  }
 
  // Downscale an uploaded image before storing it, to keep localStorage under quota.
  function gwbDownscaleImage(img, maxDim) {
    maxDim = maxDim || 1600;
    var w = img.naturalWidth || 0, h = img.naturalHeight || 0;
    if (!w || !h || Math.max(w, h) <= maxDim) return { src: img.src, width: w, height: h };
    var scale = maxDim / Math.max(w, h);
    var cw = Math.round(w * scale), ch = Math.round(h * scale);
    try {
      var canvas = document.createElement('canvas');
      canvas.width = cw; canvas.height = ch;
      canvas.getContext('2d').drawImage(img, 0, 0, cw, ch);
      return { src: canvas.toDataURL('image/jpeg', 0.85), width: cw, height: ch };
    } catch (e) {
      return { src: img.src, width: w, height: h };
    }
  }
 
  function getMobileLayoutForSlot(slot) {
    var ratio = getAspectRatio(slot.format);
    var widthPct = getWidthPercentForFormat(slot.format);
    var stageRect = stage.getBoundingClientRect();
    var stageWidth = Math.max(stageRect.width, 1);
    var stageHeight = Math.max(stageRect.height, 1);
    var heightPct = widthPct * ratio * (stageWidth / stageHeight);
    var xPct = (typeof slot.xPct === 'number') ? slot.xPct : (50 - widthPct / 2);
    var yPct = (typeof slot.yPct === 'number') ? slot.yPct : (50 - heightPct / 2);
    var mobileSlot = {
      widthPct: widthPct,
      format: slot.format,
      xPct: xPct,
      yPct: yPct
    };
    clampSlotPercent(mobileSlot);
    return { xPct: mobileSlot.xPct, yPct: mobileSlot.yPct, widthPct: widthPct, heightPct: heightPct };
  }
 
  function renderMobilePlacementControls() {
    if (!mobileSlotSwitchStage) return;
    var mobile = isMobileMode();
    mobileSlotSwitchStage.hidden = !mobile;
    if (!mobile) {
      mobileSlotSwitchStage.innerHTML = '';
      if (mobileDrawer) mobileDrawer.hidden = true;
      return;
    }
    mobileSlotSwitchStage.innerHTML = state.slots.map(function(slot) {
      return '<button type="button" class="gwb__mobile-slot-btn' + (slot.id === state.activeSlotId ? ' is-active' : '') + '" data-mobile-slot="' + slot.id + '">Affiche ' + slot.id + '</button>';
    }).join('');
    renderMobileDrawer();
  }
 
  function renderMobileDrawer() {
    if (!mobileDrawer || !mobileDrawerContent || !mobileDrawerTitle) return;
    var mobile = isMobileMode();
    var slot = getSlotById(state.activeSlotId);
    var open = mobile && !!state.mobileDrawerOpen && !!slot;
    mobileDrawer.hidden = !open;
    root.classList.toggle('gwb--mobile-drawer-open', open);
    if (open && !gwbDrawerWasOpen) gwbScrollStageIntoView();
    gwbDrawerWasOpen = open;
    if (!open) return;
    var productLabel = slot.product ? slot.product.title : 'Aucun produit sélectionné';
    var formats = getAvailableFormatsForFinish(slot);
    var finishes = getAvailableFinishes(slot);
    var price = getVariantPrice(slot);
    mobileDrawerTitle.textContent = 'Affiche ' + slot.id;
    mobileDrawerContent.innerHTML =
      '<div class="gwb__mobile-drawer-product">' +
        '<div class="gwb__mobile-drawer-summary">' + escapeHtml(productLabel) + '</div>' +
        '<div class="gwb__mobile-drawer-price">' + (price ? formatMoney(price) : 'Prix : —') + '</div>' +
        '<div class="gwb__slot-actions-row">' +
          '<button type="button" class="gwb__slot-select-btn" data-choose-product="' + slot.id + '">Choisir le visuel</button>' +
          '<button type="button" class="gwb__secondary-btn" data-duplicate-slot="' + slot.id + '">Dupliquer</button>' +
          '<button type="button" class="gwb__secondary-btn" data-reset-slot="' + slot.id + '">Réinit.</button>' +
        '</div>' +
      '</div>' +
      renderPills('format', slot.id, 'Format', formats, slot.format) +
      '<div>' + renderPills('finish', slot.id, 'Finition', finishes, slot.finish) + '<div class="gwb__slot-note">' + (slot.finish === 'Poster' ? 'Passez en Encadrée pour un rendu galerie' : '&nbsp;') + '</div></div>';
  }
 
  function applyEdgeSnap(slot) {
    var threshold = 2.2;
    var heightPct = getHeightPercent(slot);
    if (slot.xPct < threshold) slot.xPct = 0;
    if (slot.yPct < threshold) slot.yPct = 0;
    if (100 - (slot.xPct + slot.widthPct) < threshold) slot.xPct = 100 - slot.widthPct;
    if (100 - (slot.yPct + heightPct) < threshold) slot.yPct = 100 - heightPct;
    clampSlotPercent(slot);
  }
 
  function saveState() {
    try {
      var payload = {
        activeScene: state.activeScene,
        count: state.count,
        activePreset: state.activePreset,
        activeSlotId: state.activeSlotId,
        spacingMode: state.spacingMode,
        customPhoto: state.customPhoto.enabled ? {
          enabled: true,
          src: state.customPhoto.src,
          x: state.customPhoto.x,
          y: state.customPhoto.y,
          naturalWidth: state.customPhoto.naturalWidth,
          naturalHeight: state.customPhoto.naturalHeight
        } : { enabled: false },
        slots: state.slots.map(function(slot) {
          return {
            id: slot.id,
            xPct: slot.xPct,
            yPct: slot.yPct,
            format: slot.format,
            finish: slot.finish,
            productId: slot.product ? slot.product.id : null,
            variantId: slot.variantId || null,
            locked: !!slot.locked,
          };
        })
      };
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }
 
  function loadState() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }
 
  function applyRestoredStateBasic(data) {
    if (!data) return;
    if (data.activeScene && DECORS[data.activeScene]) {
      state.activeScene = data.activeScene;
      stage.style.setProperty('--scene-image', 'url(' + DECORS[state.activeScene].url + ')');
      state.stageRatio = DECORS[state.activeScene].ratio || state.stageRatio;
    }
    state.count = Math.max(1, Math.min(6, Number(data.count || state.count)));
    preserveSlots(state.count);
    state.activePreset = data.activePreset || state.activePreset;
    state.activeSlotId = Number(data.activeSlotId || state.activeSlotId || 1);
    state.spacingMode = data.spacingMode || state.spacingMode;
    if (Array.isArray(data.slots)) {
      data.slots.slice(0, state.count).forEach(function(saved, index) {
        var slot = state.slots[index];
        if (!slot || slot.locked) return;
        slot.xPct = typeof saved.xPct === 'number' ? saved.xPct : slot.xPct;
        slot.yPct = typeof saved.yPct === 'number' ? saved.yPct : slot.yPct;
        slot.format = saved.format || slot.format;
        slot.widthPct = getWidthPercentForFormat(slot.format);
        slot.finish = saved.finish || slot.finish;
        slot.variantId = saved.variantId || null;
        slot.locked = !!saved.locked;
        clampSlotPercent(slot);
      });
    }
  }
 
  function hydrateProductsFromState() {
    if (!restoredState || !Array.isArray(restoredState.slots) || !state.products.length) return;
    restoredState.slots.slice(0, state.count).forEach(function(saved, index) {
      var slot = state.slots[index];
      if (!slot) return;
      if (saved && saved.productId) {
        var product = state.products.find(function(item) { return String(item.id) === String(saved.productId); });
        if (product) {
          slot.product = product;
          slot.format = saved.format || slot.format;
          slot.widthPct = getWidthPercentForFormat(slot.format);
          slot.finish = saved.finish || slot.finish;
          slot.image = getSlotImageForFinish(product, slot.finish);
          ensureVariant(slot);
          if (saved.variantId && product.variants.some(function(v){ return Number(v.id) === Number(saved.variantId); })) {
            slot.variantId = saved.variantId;
          }
        }
      }
    });
  }
 
  function getSpacingProfile() {
    return {
      serre: { rowGap: 3.2, horizontalGap: 1.2, maxWidth: 72, offsetScale: 0.75 },
      equilibre: { rowGap: 4.2, horizontalGap: 1.8, maxWidth: 68, offsetScale: 1 },
      aere: { rowGap: 5.6, horizontalGap: 2.8, maxWidth: 78, offsetScale: 1.2 }
    }[state.spacingMode] || { rowGap: 4.2, horizontalGap: 1.8, maxWidth: 68, offsetScale: 1 };
  }
 
  function centerComposition() {
    if (!state.slots.length) return;
    var movable = state.slots.filter(function(slot){ return !slot.locked; });
    var targets = movable.length ? movable : state.slots.slice();
    if (!targets.length) return;
 
    var minLeft = Infinity, maxRight = -Infinity, minTop = Infinity, maxBottom = -Infinity;
    targets.forEach(function(slot){
      var rect = getSlotRectPct(slot);
      minLeft = Math.min(minLeft, rect.left);
      maxRight = Math.max(maxRight, rect.right);
      minTop = Math.min(minTop, rect.top);
      maxBottom = Math.max(maxBottom, rect.bottom);
    });
 
    if (!isFinite(minLeft) || !isFinite(maxRight)) return;
    var currentCenterX = (minLeft + maxRight) / 2;
    var currentCenterY = (minTop + maxBottom) / 2;
    var deltaX = 50 - currentCenterX;
    var deltaY = 42 - currentCenterY;
 
    targets.forEach(function(slot){
      slot.xPct += deltaX;
      slot.yPct += deltaY;
      clampSlotPercent(slot);
    });
 
    resolvePresetCollisions(targets);
    renderAll();
    saveState();
  }
 
  function updatePresetAvailability() {
    var allLocked = !!state.slots.length && state.slots.every(function(slot){ return !!slot.locked; });
    root.querySelectorAll('[data-preset]').forEach(function(btn){
      btn.disabled = allLocked;
    });
    if (resetPresetBtn) resetPresetBtn.disabled = allLocked;
    if (centerCompositionBtn) centerCompositionBtn.disabled = !state.slots.length;
  }
 
 
  
function setSlotCenter(slot, centerXPct, centerYPct) {
    slot.widthPct = getWidthPercentForFormat(slot.format);
    var heightPct = getHeightPercent(slot);
    slot.xPct = centerXPct - (slot.widthPct / 2);
    slot.yPct = centerYPct - (heightPct / 2);
    clampSlotPercent(slot);
  }
 
  function getSlotCenter(slot) {
    slot.widthPct = getWidthPercentForFormat(slot.format);
    return {
      x: slot.xPct + (slot.widthPct / 2),
      y: slot.yPct + (getHeightPercent(slot) / 2)
    };
  }
 
  function distributeRowByCenters(slots, centerYPct, desiredGapPct, maxRowWidthPct) {
    if (!slots.length) return false;
    var desiredGap = typeof desiredGapPct === 'number' ? desiredGapPct : 2.2;
    var maxRowWidth = typeof maxRowWidthPct === 'number' ? maxRowWidthPct : 74;
    var totalWidth = 0;
    slots.forEach(function(slot) {
      slot.widthPct = getWidthPercentForFormat(slot.format);
      totalWidth += slot.widthPct;
    });
    var gapsCount = Math.max(0, slots.length - 1);
    var fittedGap = desiredGap;
    if (gapsCount > 0) {
      fittedGap = Math.min(desiredGap, Math.max(1.4, (maxRowWidth - totalWidth) / gapsCount));
    }
    var totalRowWidth = totalWidth + (fittedGap * gapsCount);
    var startX = 50 - (totalRowWidth / 2);
    var currentLeft = startX;
    slots.forEach(function(slot) {
      var centerX = currentLeft + (slot.widthPct / 2);
      setSlotCenter(slot, centerX, centerYPct);
      currentLeft += slot.widthPct + fittedGap;
    });
    return true;
  }
 
  function getMaxSlotHeightPct(slots) {
    var maxHeight = 0;
    slots.forEach(function(slot) {
      slot.widthPct = getWidthPercentForFormat(slot.format);
      maxHeight = Math.max(maxHeight, getHeightPercent(slot));
    });
    return maxHeight;
  }
 
  function distributeTwoRows(topRow, bottomRow, blockCenterYPct, rowGapPct, rowGapHorizontalPct, maxRowWidthPct, topYOffsetBudget, bottomYOffsetBudget) {
    var topMax = getMaxSlotHeightPct(topRow);
    var bottomMax = getMaxSlotHeightPct(bottomRow);
    var gap = typeof rowGapPct === 'number' ? rowGapPct : 4.2;
    var topBudget = typeof topYOffsetBudget === 'number' ? Math.abs(topYOffsetBudget) : 0;
    var bottomBudget = typeof bottomYOffsetBudget === 'number' ? Math.abs(bottomYOffsetBudget) : 0;
    var protectedGap = gap + topBudget + bottomBudget + 0.8;
    var totalHeight = topMax + bottomMax + protectedGap;
    var topCenterY = blockCenterYPct - (totalHeight / 2) + (topMax / 2);
    var bottomCenterY = topCenterY + (topMax / 2) + protectedGap + (bottomMax / 2);
    distributeRowByCenters(topRow, topCenterY, rowGapHorizontalPct, maxRowWidthPct);
    distributeRowByCenters(bottomRow, bottomCenterY, rowGapHorizontalPct, maxRowWidthPct);
    return true;
  }
 
  function applyRowOffsets(slots, xOffsets, yOffsets, maxXShift) {
    if (!slots.length) return;
    var safeShift = typeof maxXShift === 'number' ? maxXShift : 0.9;
    slots.forEach(function(slot, idx) {
      var center = getSlotCenter(slot);
      var dx = xOffsets && typeof xOffsets[idx] === 'number' ? xOffsets[idx] : 0;
      var dy = yOffsets && typeof yOffsets[idx] === 'number' ? yOffsets[idx] : 0;
      dx = Math.max(-safeShift, Math.min(safeShift, dx));
      setSlotCenter(slot, center.x + dx, center.y + dy);
    });
  }
 
 
  function getSlotRectPct(slot) {
    slot.widthPct = getWidthPercentForFormat(slot.format);
    var heightPct = getHeightPercent(slot);
    return {
      left: slot.xPct,
      top: slot.yPct,
      right: slot.xPct + slot.widthPct,
      bottom: slot.yPct + heightPct,
      width: slot.widthPct,
      height: heightPct,
      centerX: slot.xPct + (slot.widthPct / 2),
      centerY: slot.yPct + (heightPct / 2)
    };
  }
 
  function resolvePresetCollisions(slots) {
    if (!slots || slots.length < 2) return;
    var safety = 0;
    var marginX = 1.2;
    var marginY = 1.6;
 
    while (safety < 60) {
      var hadCollision = false;
 
      for (var i = 0; i < slots.length; i++) {
        for (var j = i + 1; j < slots.length; j++) {
          var a = slots[i];
          var b = slots[j];
          var ra = getSlotRectPct(a);
          var rb = getSlotRectPct(b);
 
          var overlapX = Math.min(ra.right, rb.right) - Math.max(ra.left, rb.left);
          var overlapY = Math.min(ra.bottom, rb.bottom) - Math.max(ra.top, rb.top);
 
          if (overlapX > -marginX && overlapY > -marginY) {
            hadCollision = true;
 
            var requiredX = overlapX + marginX;
            var requiredY = overlapY + marginY;
 
            if (requiredY >= requiredX) {
              var pushY = Math.max(0, requiredY / 2);
              var aCenter = getSlotCenter(a);
              var bCenter = getSlotCenter(b);
              if (aCenter.y <= bCenter.y) {
                setSlotCenter(a, aCenter.x, aCenter.y - pushY);
                setSlotCenter(b, bCenter.x, bCenter.y + pushY);
              } else {
                setSlotCenter(a, aCenter.x, aCenter.y + pushY);
                setSlotCenter(b, bCenter.x, bCenter.y - pushY);
              }
            } else {
              var pushX = Math.max(0, requiredX / 2);
              var aCenterX = getSlotCenter(a);
              var bCenterX = getSlotCenter(b);
              if (aCenterX.x <= bCenterX.x) {
                setSlotCenter(a, aCenterX.x - pushX, aCenterX.y);
                setSlotCenter(b, bCenterX.x + pushX, bCenterX.y);
              } else {
                setSlotCenter(a, aCenterX.x + pushX, aCenterX.y);
                setSlotCenter(b, bCenterX.x - pushX, bCenterX.y);
              }
            }
          }
        }
      }
 
      if (!hadCollision) break;
      safety += 1;
    }
  }
 
  // Generateurs de decalages verticaux (en % de la scene) par composition.
  function gwbZeros(len) { var a = []; for (var i = 0; i < len; i++) a.push(0); return a; }
  function gwbArchOffsets(len, amp) {
    // Arche : centre remonte (-amp), bords descendus (+amp).
    var out = [];
    for (var i = 0; i < len; i++) {
      var d = len > 1 ? Math.abs((i / (len - 1)) - 0.5) * 2 : 0; // 0 au centre, 1 aux extremites
      out.push(amp * (2 * d - 1));
    }
    return out;
  }
  function gwbStaggerOffsets(len, amp) {
    // Zigzag alterne haut/bas, legerement asymetrique.
    var out = [];
    for (var i = 0; i < len; i++) out.push((i % 2 === 0 ? -1 : 1) * amp * (1 - i * 0.12));
    return out;
  }
 
  function applyPreset(preset) {
    state.activePreset = preset;
    var movableSlots = state.slots.filter(function(slot) { return !slot.locked; });
    var hasMovedAtLeastOne = movableSlots.length > 0;
 
    var spacing = getSpacingProfile();
    // Amplitude verticale clairement distincte par composition (modulee par l'espacement).
    var ampY = (preset === 'symetrique' ? 0 : (preset === 'harmonieux' ? 3.5 : 6.5)) * spacing.offsetScale;
 
    function patternFor(len) {
      if (preset === 'harmonieux') return gwbArchOffsets(len, ampY);
      if (preset === 'eclectique') return gwbStaggerOffsets(len, ampY);
      return gwbZeros(len);
    }
    function applyPattern(row) {
      if (!row.length) return;
      applyRowOffsets(row, gwbZeros(row.length), patternFor(row.length), 0.6);
    }
 
    if (movableSlots.length <= 3) {
      distributeRowByCenters(movableSlots, 38, spacing.horizontalGap, spacing.maxWidth + 3);
      applyPattern(movableSlots);
    } else {
      var topCount = movableSlots.length === 4 ? 2 : Math.ceil(movableSlots.length / 2);
      var topRow = movableSlots.slice(0, topCount);
      var bottomRow = movableSlots.slice(topCount);
      // Reserve verticale entre rangees proportionnelle a l'amplitude -> pas de collision.
      distributeTwoRows(topRow, bottomRow, 41, spacing.rowGap, spacing.horizontalGap, spacing.maxWidth, ampY, ampY);
      applyPattern(topRow);
      applyPattern(bottomRow);
    }
 
    root.querySelectorAll('[data-preset]').forEach(function(btn) {
      var active = btn.getAttribute('data-preset') === preset;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
 
    if (!hasMovedAtLeastOne && state.slots.length && messageEl) {
      messageEl.textContent = 'Toutes les affiches sont verrouillées. Déverrouillez-en au moins une pour appliquer une composition.';
    } else if (messageEl && messageEl.textContent === 'Toutes les affiches sont verrouillées. Déverrouillez-en au moins une pour appliquer une composition.') {
      messageEl.textContent = '';
    }
 
    resolvePresetCollisions(movableSlots);
 
    state.mobileFocusSlotId = isMobileMode() ? state.activeSlotId : null;
    renderAll();
    saveState();
  }
 
  function renderGuides() {
    if (!stageGuides) return;
    var html = '';
    if (state.snapGuides.x !== null && state.snapGuides.x !== undefined) {
      html += '<div class="gwb__stage-guide gwb__stage-guide--v" style="left:' + state.snapGuides.x + '%;"></div>';
    }
    if (state.snapGuides.y !== null && state.snapGuides.y !== undefined) {
      html += '<div class="gwb__stage-guide gwb__stage-guide--h" style="top:' + state.snapGuides.y + '%;"></div>';
    }
    stageGuides.innerHTML = html;
  }
 
  function getAvailableFormats(slot) {
    if (!slot.product) return FORMAT_LABELS.slice();
    return slot.product.sizes.slice();
  }
 
  function getAvailableFormatsForFinish(slot) {
    if (!slot.product) return FORMAT_LABELS.slice();
    return slot.product.variants
      .filter(function(v) { return v.finish === slot.finish && v.available !== false; })
      .map(function(v) { return v.size; })
      .filter(function(v, i, a) { return a.indexOf(v) === i; });
  }
 
  function getAvailableFinishes(slot) {
    if (!slot.product) return ['Poster', 'Encadrée'];
    var variantsForFormat = slot.product.variants.filter(function(v) { return v.size === slot.format && v.available; });
    var finishes = Array.from(new Set(variantsForFormat.map(function(v) { return v.finish; }).filter(Boolean)));
    return finishes.length ? finishes : slot.product.finishes.slice();
  }
 
  function renderPills(type, slotId, label, options, selectedValue) {
    return '' +
      '<div class="gwb__field">' +
        '<label>' + escapeHtml(label) + '</label>' +
        '<div class="gwb__pill-group">' +
          options.map(function(option) {
            return '<button type="button" class="gwb__pill' + (option === selectedValue ? ' is-active' : '') + '" data-pill-option="' + type + '" data-slot-id="' + slotId + '" data-value="' + escapeHtml(option) + '">' + escapeHtml(type === 'format' ? getDisplayFormatLabel(option) : option) + '</button>';
          }).join('') +
        '</div>' +
      '</div>';
  }
 
  function renderSlots() {
    slotControls.innerHTML = state.slots.map(function(slot) {
      var productLabel = slot.product ? slot.product.title : 'Aucun produit sélectionné';
      var formats = getAvailableFormats(slot);
      var finishes = getAvailableFinishes(slot);
      var invalid = !slot.variantId;
      var slotPrice = getVariantPrice(slot);
      return '' +
        '<div class="gwb__slot-card' + (slot.id === state.activeSlotId ? ' is-active' : '') + (invalid ? ' is-invalid' : '') + '" data-slot-card="' + slot.id + '">' +
          '<div class="gwb__slot-card-head">' +
            '<div>' +
              '<div class="gwb__slot-card-top">' +
                '<div class="gwb__slot-card-title">Affiche ' + slot.id + '</div>' +
                '<button type="button" class="gwb__slot-lock' + (slot.locked ? ' is-locked' : '') + '" data-toggle-lock="' + slot.id + '" aria-pressed="' + (slot.locked ? 'true' : 'false') + '" aria-label="' + (slot.locked ? 'Déverrouiller' : 'Verrouiller') + '">' + (slot.locked ? '🔒' : '🔓') + '</button>' +
              '</div>' +
              '<div class="gwb__slot-card-meta">' + escapeHtml(productLabel) + '</div>' +
              '<div class="gwb__slot-price">' + (slotPrice ? formatMoney(slotPrice) : 'Prix : —') + '</div>' +
            '</div>' +
            '<div class="gwb__slot-actions-row">' +
              '<button type="button" class="gwb__slot-select-btn" data-choose-product="' + slot.id + '">Choisir</button>' +
              '<button type="button" class="gwb__secondary-btn" data-duplicate-slot="' + slot.id + '">Dupliquer</button>' +
              '<button type="button" class="gwb__secondary-btn" data-reset-slot="' + slot.id + '">Réinit.</button>' +
            '</div>' +
            renderPills('format', slot.id, 'Format', formats, slot.format) +
            '<div>' + renderPills('finish', slot.id, 'Finition', finishes, slot.finish) + '<div class="gwb__slot-note">' + (slot.finish === 'Poster' ? 'Passez en Encadrée pour un rendu galerie' : '&nbsp;') + '</div></div>' +
          '</div>' +
        '</div>';
    }).join('');
  }
 
  function placeholderSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="4" y="5" width="16" height="14" rx="1.5"></rect><path d="M8 14l2.5-2.5a1 1 0 0 1 1.4 0L16 15"></path><circle cx="15.5" cy="9.5" r="1.3"></circle></svg>';
  }
 
  function shouldHideStageMeta() {
    if (isMobileMode()) return true;
    return !!state.drag || !!state.activeSlotId;
  }
 
  function renderStage() {
    var hideMeta = shouldHideStageMeta();
    stage.classList.toggle('is-preview-clean', hideMeta);
 
    stageOverlay.innerHTML = state.slots.map(function(slot, index) {
      var mobileLayout = isMobileMode() ? getMobileLayoutForSlot(slot) : null;
      if (!mobileLayout) {
        clampSlotPercent(slot);
      }
      var heightPct = mobileLayout ? mobileLayout.heightPct : getHeightPercent(slot);
      var widthPct = mobileLayout ? mobileLayout.widthPct : slot.widthPct;
      var xPct = mobileLayout ? mobileLayout.xPct : slot.xPct;
      var yPct = mobileLayout ? mobileLayout.yPct : slot.yPct;
      var mobileFocus = isMobileMode() && !!state.mobileFocusSlotId;
      var activeOnStage = isMobileMode() ? (state.mobileFocusSlotId === slot.id) : (slot.id === state.activeSlotId);
      var finishClass = (slot.finish === 'Encadrée' ? ' is-framed' : ' is-poster') + (slot.locked ? ' is-locked' : '');
      return '' +
        '<div class="gwb__frame-slot' + finishClass + (activeOnStage ? ' is-active' : '') + (slot.product && !slot.variantId ? ' is-invalid' : '') + '" data-slot="' + slot.id + '" style="left:' + xPct + '%;top:' + yPct + '%;width:' + widthPct + '%;height:' + heightPct + '%;z-index:' + (10 + index) + ';" tabindex="0" role="button" aria-label="Affiche ' + slot.id + ' - utilisez les flèches du clavier pour déplacer l’affiche">' +
          (hideMeta || mobileFocus ? '' : '<div class="gwb__frame-slot-label">Affiche ' + slot.id + '</div>') +
          '<div class="gwb__frame-slot-inner">' +
            (slot.image ? '<img class="gwb__frame-slot-image" src="' + escapeHtml(slot.image) + '" alt="' + escapeHtml(slot.product ? slot.product.title : 'Aperçu affiche') + '">' : '<div class="gwb__frame-slot-placeholder">' + placeholderSvg() + '</div>') +
          '</div>' +
          (hideMeta || mobileFocus ? '' : '<div class="gwb__frame-slot-format-badge">' + escapeHtml(getDisplayFormatLabel(slot.format)) + '</div>') +
          (hideMeta || isMobileMode() || mobileFocus ? '' : '<div class="gwb__frame-slot-size-badge">' + escapeHtml(getRealSizeBadge(slot.format)) + '</div>') +
        '</div>';
    }).join('');
  }
 
  function updateSummary() {
    var selectedSlots = state.slots.filter(function(slot) { return !!slot.product; });
    var selected = selectedSlots.length;
    var ready = state.slots.length > 0 && state.slots.every(function(slot) { return !!slot.variantId; });
    var total = state.slots.reduce(function(sum, slot) { return sum + getVariantPrice(slot); }, 0);
    summaryText.textContent = selected ? (selected + ' affiche' + (selected > 1 ? 's' : '') + ' sélectionnée' + (selected > 1 ? 's' : '') + ' sur ' + state.slots.length + '.') : 'Aucune affiche sélectionnée.';
    if (summaryDetailsEl) {
      summaryDetailsEl.innerHTML = selectedSlots.map(function(slot) {
        return '<span class="gwb__summary-pill"><strong>Affiche ' + slot.id + '</strong> ' + escapeHtml(getDisplayFormatLabel(slot.format)) + ' · ' + escapeHtml(slot.finish || 'Poster') + '</span>';
      }).join('');
    }
    if (totalPriceEl) totalPriceEl.textContent = selected ? ('Total : ' + formatMoney(total)) : 'Total : —';
    addBtn.disabled = !ready;
    updatePresetAvailability();
  }
 
  function resetSlot(slotId) {
    var slot = getSlotById(slotId);
    if (!slot) return;
    slot.product = null;
    slot.image = '';
    slot.variantId = null;
    slot.format = '30×40cm';
    slot.finish = 'Poster';
    slot.widthPct = getWidthPercentForFormat(slot.format);
    clampSlotPercent(slot);
    renderAll();
    saveState();
  }
 
  function duplicateSlotFrom(slotId) {
    var source = getSlotById(slotId);
    if (!source || !source.product) return;
    var target = state.slots.find(function(slot){ return slot.id !== source.id && !slot.product; }) ||
                 state.slots.find(function(slot){ return slot.id !== source.id; });
    if (!target) return;
    target.product = source.product;
    target.image = source.image;
    target.variantId = source.variantId;
    target.format = source.format;
    target.finish = source.finish;
    target.widthPct = getWidthPercentForFormat(target.format);
    ensureVariant(target);
    clampSlotPercent(target);
    state.activeSlotId = target.id;
    renderAll();
    saveState();
  }
 
  function renderAll() {
    renderSlots();
    renderMobilePlacementControls();
    renderStage();
    renderGuides();
    updateSummary();
  }
 
  function setActiveSlot(id) {
    state.activeSlotId = id;
    if (isMobileMode() && state.mobileFocusSlotId) state.mobileDrawerOpen = true;
    renderAll();
    saveState();
  }
var gwbLastFocused = null;
  function openModal(slotId) {
    state.activeSlotId = slotId;
    modal.hidden = false;
    gwbLastFocused = document.activeElement;
    modalSlotLabel.textContent = '#' + slotId;
    renderProducts();
    document.body.style.overflow = 'hidden';
    var gwbSearch = document.getElementById('gwb-product-search');
    if (gwbSearch) gwbSearch.focus();
  }
 
  function closeModal() {
    modal.hidden = true;
    if (gwbLastFocused && gwbLastFocused.focus) gwbLastFocused.focus();
    document.body.style.overflow = '';
  }
 
  function renderProducts() {
    var q = state.search.trim().toLowerCase();
    state.filteredProducts = state.products.filter(function(product) { return !q || product.title.toLowerCase().indexOf(q) !== -1; });
 
    if (!state.products.length) {
      modalStatus.textContent = 'Aucun produit disponible dans cette collection pour le moment.';
      modalStatus.style.display = 'block';
      productGrid.innerHTML = '';
      loadMoreBtn.hidden = true;
      return;
    }
 
    if (!state.filteredProducts.length) {
      modalStatus.textContent = 'Aucun produit ne correspond à votre recherche.';
      modalStatus.style.display = 'block';
      productGrid.innerHTML = '';
      loadMoreBtn.hidden = true;
      return;
    }
 
    modalStatus.style.display = 'none';
    var visible = state.filteredProducts.slice(0, state.visibleCount);
    productGrid.innerHTML = visible.map(function(product) {
      var imageMarkup = product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '">' : '<div class="gwb__frame-slot-placeholder">' + placeholderSvg() + '</div>';
      return '' +
        '<button type="button" class="gwb-modal__card" data-product-id="' + product.id + '">' +
          '<div class="gwb-modal__card-media">' + imageMarkup + '</div>' +
          '<div class="gwb-modal__card-title">' + escapeHtml(product.title) + '</div>' +
          '<div class="gwb-modal__card-meta">' + product.sizes.length + ' format(s) disponible(s)</div>' +
        '</button>';
    }).join('');
 
    loadMoreBtn.hidden = state.visibleCount >= state.filteredProducts.length || state.visibleCount >= 250;
  }
 
  function selectProduct(productId) {
    var slot = getSlotById(state.activeSlotId);
    var product = state.products.find(function(item) { return String(item.id) === String(productId); });
    if (!slot || !product) return;
 
    slot.product = product;
    slot.image = getSlotImageForFinish(product, slot.finish);
    var initialVariant = product.variants[0] || null;
    if (initialVariant) {
      slot.format = initialVariant.size || slot.format;
      slot.finish = initialVariant.finish || slot.finish;
      slot.variantId = initialVariant.id;
    } else {
      slot.variantId = null;
    }
    slot.widthPct = getWidthPercentForFormat(slot.format);
    clampSlotPercent(slot);
    closeModal();
    renderAll();
    saveState();
  }
 
  function fetchProducts() {
    modalStatus.textContent = 'Chargement des produits...';
    fetch(PRODUCTS_URL, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function(data) {
        state.products = normalizeProducts(data.products || []);
        state.visibleCount = 20;
        hydrateProductsFromState();
        renderProducts();
        renderAll();
      })
      .catch(function() {
        state.products = [];
        renderProducts();
      });
  }
 
  function addToCart() {
    if (addBtn && addBtn.disabled) return;
    var invalidSlots = [];
    var items = state.slots.map(function(slot) {
      if (!slot.variantId) invalidSlots.push(slot.id);
      return slot.variantId ? {
      id: slot.variantId,
      quantity: 1,
      properties: {
      'Composition': 'Gallery Wall',
      'Emplacement': 'Affiche ' + slot.id,
      'Format': getDisplayFormatLabel(slot.format),
      'Finition': slot.finish,
      'Position mur': Math.round(slot.xPct) + '% / ' + Math.round(slot.yPct) + '% (largeur ' + Math.round(slot.widthPct) + '%)'
      }
      } : null;
    }).filter(Boolean);
 
    if (invalidSlots.length) {
      messageEl.textContent = 'Veuillez compléter toutes les affiches avant l’ajout au panier.';
      state.activeSlotId = invalidSlots[0];
      renderAll();
      saveState();
      return;
    }
 
    messageEl.textContent = 'Ajout au panier...';
    if (addBtn) addBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(function() {
      messageEl.textContent = 'Les affiches ont été ajoutées au panier.';
      if (addBtn) addBtn.disabled = false;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })
    .catch(function() {
      messageEl.textContent = 'Une erreur est survenue lors de l’ajout au panier.';
      if (addBtn) addBtn.disabled = false;
    });
  }
 
  function getPoint(event) {
    if (event.touches && event.touches[0]) return { x: event.touches[0].clientX, y: event.touches[0].clientY };
    if (event.changedTouches && event.changedTouches[0]) return { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
    return { x: event.clientX, y: event.clientY };
  }
 
  function startSlotDrag(event, slotId) {
    var slot = getSlotById(slotId);
    if (!slot) return;
    var point = getPoint(event);
    var stageRect = stage.getBoundingClientRect();
    var stageWidth = Math.max(stageRect.width, 1);
    var stageHeight = Math.max(stageRect.height, 1);
    var widthPct = isMobileMode() ? getWidthPercentForFormat(slot.format) : slot.widthPct;
    var heightPct = widthPct * getAspectRatio(slot.format) * (stageWidth / stageHeight);
    var slotCenterX = (slot.xPct + (widthPct / 2)) / 100 * stageRect.width;
    var slotCenterY = (slot.yPct + (heightPct / 2)) / 100 * stageRect.height;
    state.drag = {
      slotId: slotId,
      startX: point.x,
      startY: point.y,
      baseXPct: slot.xPct,
      baseYPct: slot.yPct,
      touchOffsetX: point.x - (stageRect.left + slotCenterX),
      touchOffsetY: point.y - (stageRect.top + slotCenterY)
    };
    state.activeSlotId = slotId;
    if (isMobileMode()) { state.mobileFocusSlotId = slotId; }
    renderAll();
  }
 
  function startPhotoDrag(event) {
    if (!state.customPhoto.enabled) return;
    var point = getPoint(event);
    state.customPhoto.dragging = true;
    state.customPhoto.startX = point.x;
    state.customPhoto.startY = point.y;
    state.customPhoto.baseX = state.customPhoto.x;
    state.customPhoto.baseY = state.customPhoto.y;
    customPhotoLayer.classList.add('is-dragging');
  }
 
  function applyStageRatio(ratio) {
    state.stageRatio = ratio || (1600 / 1100);
    stage.style.setProperty('--gwb-stage-ratio', String(state.stageRatio));
    renderStage();
  }
 
  function syncPhotoSlidersFromState() {
    if (!photoHorizontal || !photoVertical) return;
    var stageRect = stage.getBoundingClientRect();
    var maxX = Math.max(1, (state.customPhoto.displayWidth - stageRect.width) / 2);
    var maxY = Math.max(1, (state.customPhoto.displayHeight - stageRect.height) / 2);
    photoHorizontal.value = String(Math.round((state.customPhoto.x / maxX) * 100));
    photoVertical.value = String(Math.round((state.customPhoto.y / maxY) * 100));
  }
 
  function applyPhotoTransform() {
    customPhotoImage.style.objectPosition = 'calc(50% + ' + state.customPhoto.x + 'px) calc(50% + ' + state.customPhoto.y + 'px)';
    syncPhotoSlidersFromState();
  }
 
  function fitCustomPhoto() {
    if (!state.customPhoto.naturalWidth || !state.customPhoto.naturalHeight) return;
    var stageRect = stage.getBoundingClientRect();
    var coverScale = Math.max(stageRect.width / state.customPhoto.naturalWidth, stageRect.height / state.customPhoto.naturalHeight);
    state.customPhoto.displayWidth = Math.ceil(state.customPhoto.naturalWidth * coverScale);
    state.customPhoto.displayHeight = Math.ceil(state.customPhoto.naturalHeight * coverScale);
    customPhotoImage.style.width = state.customPhoto.displayWidth + 'px';
    customPhotoImage.style.height = state.customPhoto.displayHeight + 'px';
    var maxX = Math.max(0, (state.customPhoto.displayWidth - stageRect.width) / 2);
    var maxY = Math.max(0, (state.customPhoto.displayHeight - stageRect.height) / 2);
    state.customPhoto.x = Math.max(-maxX, Math.min(maxX, state.customPhoto.x));
    state.customPhoto.y = Math.max(-maxY, Math.min(maxY, state.customPhoto.y));
    applyPhotoTransform();
    saveState();
  }
 
  function applySnap(slot, candidateXPct, candidateYPct) {
    var threshold = 1.2;
    var gapThreshold = 1.6;
    var galleryGap = ({ serre: 1.2, equilibre: 1.8, aere: 2.8 }[state.spacingMode] || 1.8);
    var heightPct = getHeightPercent(slot);
    var widthPct = slot.widthPct;
    var x = candidateXPct;
    var y = candidateYPct;
    var guideX = null;
    var guideY = null;
    var bestDX = threshold + 1;
    var bestDY = threshold + 1;
 
    var currentLinesX = [x, x + widthPct / 2, x + widthPct];
    var currentLinesY = [y, y + heightPct / 2, y + heightPct];
 
    state.slots.forEach(function(other) {
      if (other.id === slot.id) return;
      clampSlotPercent(other);
      var otherHeight = getHeightPercent(other);
      var otherLinesX = [other.xPct, other.xPct + other.widthPct / 2, other.xPct + other.widthPct];
      var otherLinesY = [other.yPct, other.yPct + otherHeight / 2, other.yPct + otherHeight];
      var edgeGapTargets = [
        other.xPct - galleryGap - widthPct,
        other.xPct + other.widthPct + galleryGap
      ];
      var verticalGapTargets = [
        other.yPct - galleryGap - heightPct,
        other.yPct + otherHeight + galleryGap
      ];
 
      currentLinesX.forEach(function(line) {
        otherLinesX.forEach(function(target) {
          var delta = target - line;
          var absDelta = Math.abs(delta);
          if (absDelta < bestDX && absDelta <= threshold) {
            bestDX = absDelta;
            x += delta;
            guideX = target;
            currentLinesX = [x, x + widthPct / 2, x + widthPct];
          }
        });
      });
 
      currentLinesY.forEach(function(line) {
        otherLinesY.forEach(function(target) {
          var delta = target - line;
          var absDelta = Math.abs(delta);
          if (absDelta < bestDY && absDelta <= threshold) {
            bestDY = absDelta;
            y += delta;
            guideY = target;
            currentLinesY = [y, y + heightPct / 2, y + heightPct];
          }
        });
      });
 
      edgeGapTargets.forEach(function(targetX) {
        var deltaX = targetX - x;
        if (Math.abs(deltaX) <= gapThreshold) {
          x = targetX;
          guideX = targetX + widthPct;
          currentLinesX = [x, x + widthPct / 2, x + widthPct];
        }
      });
 
      verticalGapTargets.forEach(function(targetY) {
        var deltaY = targetY - y;
        if (Math.abs(deltaY) <= gapThreshold) {
          y = targetY;
          guideY = targetY + heightPct;
          currentLinesY = [y, y + heightPct / 2, y + heightPct];
        }
      });
    });
 
    slot.xPct = x;
    slot.yPct = y;
    clampSlotPercent(slot);
    state.snapGuides.x = guideX;
    state.snapGuides.y = guideY;
  }
 
  function onPointerMove(event) {
    if (state.drag) {
      var point = getPoint(event);
      var slot = getSlotById(state.drag.slotId);
      if (!slot) return;
      var stageRect = stage.getBoundingClientRect();
      if (isMobileMode()) {
        var stageWidth = Math.max(stageRect.width, 1);
        var stageHeight = Math.max(stageRect.height, 1);
        var widthPct = getWidthPercentForFormat(slot.format);
        var heightPct = widthPct * getAspectRatio(slot.format) * (stageWidth / stageHeight);
        var centerXPx = point.x - stageRect.left - state.drag.touchOffsetX;
        var centerYPx = point.y - stageRect.top - state.drag.touchOffsetY;
        slot.xPct = ((centerXPx - ((widthPct / 100) * stageRect.width / 2)) / Math.max(stageRect.width, 1)) * 100;
        slot.yPct = ((centerYPx - ((heightPct / 100) * stageRect.height / 2)) / Math.max(stageRect.height, 1)) * 100;
        slot.widthPct = widthPct;
        clampSlotPercent(slot);
        applyEdgeSnap(slot);
        state.snapGuides.x = null;
        state.snapGuides.y = null;
      } else {
        var deltaXPct = ((point.x - state.drag.startX) / Math.max(stageRect.width, 1)) * 100;
        var deltaYPct = ((point.y - state.drag.startY) / Math.max(stageRect.height, 1)) * 100;
        applySnap(slot, state.drag.baseXPct + deltaXPct, state.drag.baseYPct + deltaYPct);
      }
      // Perf: mutate only the active slot's geometry during the drag — no innerHTML rebuild,
      // so the element under the finger is never destroyed (kills flicker / focus loss / CLS).
      var dragEl = state.drag.el || stageOverlay.querySelector('.gwb__frame-slot[data-slot="' + state.drag.slotId + '"]');
      state.drag.el = dragEl;
      if (dragEl) {
        dragEl.style.left = slot.xPct + '%';
        dragEl.style.top = slot.yPct + '%';
        dragEl.style.width = slot.widthPct + '%';
        dragEl.style.height = getHeightPercent(slot) + '%';
      }
      renderGuides();
      event.preventDefault();
      return;
    }
 
    if (state.customPhoto.dragging) {
      var pointPhoto = getPoint(event);
      var stageRectPhoto = stage.getBoundingClientRect();
      var maxX = Math.max(0, (state.customPhoto.displayWidth - stageRectPhoto.width) / 2);
      var maxY = Math.max(0, (state.customPhoto.displayHeight - stageRectPhoto.height) / 2);
      state.customPhoto.x = Math.max(-maxX, Math.min(maxX, state.customPhoto.baseX + (pointPhoto.x - state.customPhoto.startX)));
      state.customPhoto.y = Math.max(-maxY, Math.min(maxY, state.customPhoto.baseY + (pointPhoto.y - state.customPhoto.startY)));
      applyPhotoTransform();
      event.preventDefault();
    }
  }
 
  function stopInteractions() {
    var hadSlotFocus = document.activeElement && document.activeElement.classList && document.activeElement.classList.contains('gwb__frame-slot');
    var focusSlotId = hadSlotFocus ? document.activeElement.getAttribute('data-slot') : null;
    state.drag = null;
    state.snapGuides.x = null;
    state.snapGuides.y = null;
    renderStage();
    renderGuides();
    saveState();
    state.customPhoto.dragging = false;
    customPhotoLayer.classList.remove('is-dragging');
    if (focusSlotId != null) {
      var refocus = stageOverlay.querySelector('.gwb__frame-slot[data-slot="' + focusSlotId + '"]');
      if (refocus) refocus.focus();
    }
  }
 
  // Unified pointer interaction (mouse + touch + pen) with a tap/drag threshold.
  var GWB_DRAG_THRESHOLD = 8;
  function onStagePointerDown(event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    var slotTarget = event.target.closest('[data-slot]');
    if (slotTarget) {
      state.pointer = { kind: 'slot', id: event.pointerId, slotId: Number(slotTarget.getAttribute('data-slot')), startX: event.clientX, startY: event.clientY, moved: false };
      try { stage.setPointerCapture(event.pointerId); } catch (e) {}
      return;
    }
    if (state.customPhoto.enabled && (event.target === customPhotoLayer || event.target === customPhotoImage)) {
      state.pointer = { kind: 'photo', id: event.pointerId, startX: event.clientX, startY: event.clientY, moved: false };
      try { stage.setPointerCapture(event.pointerId); } catch (e) {}
    }
  }
  function onStagePointerMove(event) {
    var p = state.pointer;
    if (!p || event.pointerId !== p.id) return;
    if (!p.moved) {
      if (Math.abs(event.clientX - p.startX) < GWB_DRAG_THRESHOLD && Math.abs(event.clientY - p.startY) < GWB_DRAG_THRESHOLD) return;
      p.moved = true;
      if (p.kind === 'slot') startSlotDrag(event, p.slotId);
      else startPhotoDrag(event);
    }
    onPointerMove(event);
    event.preventDefault();
  }
  function onStagePointerUp(event) {
    var p = state.pointer;
    if (!p || event.pointerId !== p.id) return;
    try { stage.releasePointerCapture(event.pointerId); } catch (e) {}
    state.pointer = null;
    if (p.moved) {
      if (p.kind === 'slot') state.suppressClick = true; // a real drag must not also fire the tap action
      stopInteractions();
    }
    // No movement => it was a tap: let the native click event drive selection / drawer toggle.
  }
 
  root.addEventListener('click', function(event) {
    if (state.suppressClick) {
      state.suppressClick = false;
      if (event.target.closest('[data-slot]')) {
        event.preventDefault();
        return;
      }
    }
 
    var pillOption = event.target.closest('[data-pill-option]');
    if (pillOption) {
      event.preventDefault();
      event.stopPropagation();
      var optionType = pillOption.getAttribute('data-pill-option');
      var optionSlot = getSlotById(Number(pillOption.getAttribute('data-slot-id')));
      var optionValue = pillOption.getAttribute('data-value');
      if (!optionSlot) return;
 
      if (optionType === 'format') {
        var prevHeightPct = getHeightPercent(optionSlot);
        var centerXPct = optionSlot.xPct + optionSlot.widthPct / 2;
        var centerYPct = optionSlot.yPct + prevHeightPct / 2;
        optionSlot.format = optionValue;
        optionSlot.widthPct = getWidthPercentForFormat(optionSlot.format);
        var nextHeightPct = getHeightPercent(optionSlot);
        optionSlot.xPct = centerXPct - optionSlot.widthPct / 2;
        optionSlot.yPct = centerYPct - nextHeightPct / 2;
        ensureVariant(optionSlot);
        clampSlotPercent(optionSlot);
      } else if (optionType === 'finish') {
        optionSlot.finish = optionValue;
        ensureVariant(optionSlot);
        if (optionSlot.product) {
          optionSlot.image = getSlotImageForFinish(optionSlot.product, optionSlot.finish);
        }
      }
 
      renderAll();
      saveState();
      return;
    }
 
    var mobileSlotBtn = event.target.closest('[data-mobile-slot]');
    if (mobileSlotBtn) {
      event.preventDefault();
      var mobileSlotId = Number(mobileSlotBtn.getAttribute('data-mobile-slot'));
      state.activeSlotId = mobileSlotId;
      state.mobileFocusSlotId = mobileSlotId;
      state.mobileDrawerOpen = true;
      renderAll();
      return;
    }
 
    var lockBtn = event.target.closest('[data-toggle-lock]');
    if (lockBtn) {
      event.preventDefault();
      event.stopPropagation();
      var lockSlot = getSlotById(Number(lockBtn.getAttribute('data-toggle-lock')));
      if (!lockSlot) return;
      lockSlot.locked = !lockSlot.locked;
      renderAll();
      saveState();
      return;
    }
 
    var sceneBtn = event.target.closest('[data-scene]');
    if (sceneBtn) {
      state.activeScene = sceneBtn.getAttribute('data-scene');
      stage.style.setProperty('--scene-image', 'url(' + DECORS[state.activeScene].url + ')');
      applyStageRatio(DECORS[state.activeScene].ratio);
      root.querySelectorAll('[data-scene]').forEach(function(btn) {
        var active = btn === sceneBtn;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      saveState();
      return;
    }
 
    var presetBtn = event.target.closest('[data-preset]');
    if (presetBtn) {
      applyPreset(presetBtn.getAttribute('data-preset'));
      return;
    }
 
    var spacingBtn = event.target.closest('[data-spacing]');
    if (spacingBtn) {
      state.spacingMode = spacingBtn.getAttribute('data-spacing') || 'equilibre';
      root.querySelectorAll('[data-spacing]').forEach(function(btn) {
        var active = btn === spacingBtn;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      applyPreset(state.activePreset || 'symetrique');
      return;
    }
 
    if (event.target.closest('[data-duplicate-slot]')) {
      duplicateSlotFrom(Number(event.target.closest('[data-duplicate-slot]').getAttribute('data-duplicate-slot')));
      return;
    }
 
    if (event.target.closest('[data-reset-slot]')) {
      resetSlot(Number(event.target.closest('[data-reset-slot]').getAttribute('data-reset-slot')));
      return;
    }
 
    var countBtn = event.target.closest('[data-count]');
    if (countBtn) {
      state.count = Number(countBtn.getAttribute('data-count')) || 1;
      preserveSlots(state.count);
      root.querySelectorAll('[data-count]').forEach(function(btn) {
        var active = btn === countBtn;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      applyPreset(state.activePreset);
      return;
    }
 
    var chooseBtn = event.target.closest('[data-choose-product]');
    if (chooseBtn) {
      openModal(Number(chooseBtn.getAttribute('data-choose-product')));
      return;
    }
 
    var slotCard = event.target.closest('[data-slot-card]');
    if (slotCard) {
      setActiveSlot(Number(slotCard.getAttribute('data-slot-card')));
      return;
    }
 
    var slotEl = event.target.closest('[data-slot]');
    if (slotEl) {
      var clickedSlotId = Number(slotEl.getAttribute('data-slot'));
      if (isMobileMode()) {
        // Tap selects/highlights only; the drawer is opened via the "Affiche N" tabs.
        state.activeSlotId = clickedSlotId;
        state.mobileFocusSlotId = clickedSlotId;
        renderAll();
        saveState();
      } else {
        setActiveSlot(clickedSlotId);
      }
      return;
    }
 
    if (!isMobileMode() && (event.target === stage || event.target === stageOverlay)) {
      state.activeSlotId = null;
      renderAll();
      return;
    }
 
    var productBtn = event.target.closest('[data-product-id]');
    if (productBtn) {
      event.preventDefault();
      selectProduct(productBtn.getAttribute('data-product-id'));
      return;
    }
 
    if (event.target.closest('[data-close-modal]')) {
      closeModal();
    }
  });
 
  stage.addEventListener('pointerdown', onStagePointerDown);
  stage.addEventListener('pointermove', onStagePointerMove);
  stage.addEventListener('pointerup', onStagePointerUp);
  stage.addEventListener('pointercancel', onStagePointerUp);
 
  photoTrigger.addEventListener('click', function() { photoInput.click(); });
  photoRemove.addEventListener('click', function() {
    state.customPhoto.enabled = false;
    state.customPhoto.src = '';
    state.customPhoto.x = 0;
    state.customPhoto.y = 0;
    customPhotoLayer.hidden = true;
    photoRemove.hidden = true;
    if (photoPositionControls) photoPositionControls.hidden = true;
    if (photoHorizontal) photoHorizontal.value = '0';
    if (photoVertical) photoVertical.value = '0';
    photoInput.value = '';
    applyStageRatio(DECORS[state.activeScene].ratio);
    saveState();
  });
 
  photoInput.addEventListener('change', function(event) {
    var file = event.target.files && event.target.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function(loadEvent) {
      var src = loadEvent.target.result;
      var img = new Image();
      img.onload = function() {
        var scaled = gwbDownscaleImage(img, 1600);
        state.customPhoto.enabled = true;
        state.customPhoto.src = scaled.src;
        state.customPhoto.naturalWidth = scaled.width;
        state.customPhoto.naturalHeight = scaled.height;
        state.customPhoto.x = 0;
        state.customPhoto.y = 0;
        customPhotoImage.src = scaled.src;
        customPhotoImage.style.objectPosition = 'center';
        customPhotoLayer.hidden = false;
        photoRemove.hidden = false;
        if (photoPositionControls) photoPositionControls.hidden = false;
        if (photoHorizontal) photoHorizontal.value = '0';
        if (photoVertical) photoVertical.value = '0';
        applyStageRatio(scaled.width / scaled.height);
        fitCustomPhoto(); saveState();
      };
      img.src = src;
    };
    reader.readAsDataURL(file);
  });
 
  // Custom photo drag is handled by the unified stage pointer handlers above.
 
  function updatePhotoFromSliders() {
    if (!state.customPhoto.enabled) return;
    var stageRect = stage.getBoundingClientRect();
    var maxX = Math.max(0, (state.customPhoto.displayWidth - stageRect.width) / 2);
    var maxY = Math.max(0, (state.customPhoto.displayHeight - stageRect.height) / 2);
    var horizontalValue = photoHorizontal ? Number(photoHorizontal.value || 0) : 0;
    var verticalValue = photoVertical ? Number(photoVertical.value || 0) : 0;
    state.customPhoto.x = maxX * (horizontalValue / 100);
    state.customPhoto.y = maxY * (verticalValue / 100);
    applyPhotoTransform();
  }
 
  if (photoHorizontal) {
    photoHorizontal.addEventListener('input', updatePhotoFromSliders);
    photoHorizontal.addEventListener('change', updatePhotoFromSliders);
  }
  if (photoVertical) {
    photoVertical.addEventListener('input', updatePhotoFromSliders);
    photoVertical.addEventListener('change', updatePhotoFromSliders);
  }
 
  window.addEventListener('resize', function() {
    state.slots.forEach(clampSlotPercent);
    if (!isMobileMode()) {
      state.mobileDrawerOpen = false;
      state.mobileFocusSlotId = null;
    }
    renderAll();
    if (state.customPhoto.enabled) fitCustomPhoto();
  });
 
  searchInput.addEventListener('input', function() {
    state.search = searchInput.value || '';
    state.visibleCount = 20;
    renderProducts();
  });
 
  loadMoreBtn.addEventListener('click', function() {
    state.visibleCount = Math.min(250, state.visibleCount + 20);
    renderProducts();
  });
 
  if (resetPresetBtn) {
    resetPresetBtn.addEventListener('click', function() {
      applyPreset(state.activePreset || 'symetrique');
    });
  }
 
  function gwbCloseMobileDrawer() {
    state.mobileDrawerOpen = false;
    state.mobileFocusSlotId = null;
    if (mobileDrawer) mobileDrawer.style.transform = '';
    renderAll();
    saveState();
  }
  if (mobileDrawerClose) {
    mobileDrawerClose.addEventListener('click', gwbCloseMobileDrawer);
  }
 
  // Easier dismissal: swipe the drawer down, or tap its grab handle, to close it.
  if (mobileDrawer) {
    var gwbHandleEl = mobileDrawer.querySelector('.gwb__mobile-drawer-handle');
    if (gwbHandleEl) gwbHandleEl.addEventListener('click', gwbCloseMobileDrawer);
    var gwbDrawerSwipe = null;
    mobileDrawer.addEventListener('pointerdown', function(event) {
      if (!event.target.closest('.gwb__mobile-drawer-handle, .gwb__mobile-drawer-head')) return;
      if (event.target.closest('.gwb__mobile-drawer-close')) return;
      gwbDrawerSwipe = { id: event.pointerId, startY: event.clientY };
      try { mobileDrawer.setPointerCapture(event.pointerId); } catch (e) {}
    });
    mobileDrawer.addEventListener('pointermove', function(event) {
      if (!gwbDrawerSwipe || event.pointerId !== gwbDrawerSwipe.id) return;
      var dy = event.clientY - gwbDrawerSwipe.startY;
      mobileDrawer.style.transform = dy > 0 ? 'translateY(' + Math.min(dy, 360) + 'px)' : '';
    });
    var gwbEndDrawerSwipe = function(event) {
      if (!gwbDrawerSwipe || event.pointerId !== gwbDrawerSwipe.id) return;
      var dy = event.clientY - gwbDrawerSwipe.startY;
      try { mobileDrawer.releasePointerCapture(event.pointerId); } catch (e) {}
      gwbDrawerSwipe = null;
      if (dy > 60) { gwbCloseMobileDrawer(); }
      else { mobileDrawer.style.transform = ''; }
    };
    mobileDrawer.addEventListener('pointerup', gwbEndDrawerSwipe);
    mobileDrawer.addEventListener('pointercancel', gwbEndDrawerSwipe);
  }
 
  if (centerCompositionBtn) {
    centerCompositionBtn.addEventListener('click', centerComposition);
  }
 
  addBtn.addEventListener('click', addToCart);
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
    if (event.key === 'Tab' && !modal.hidden) {
    var gwbDialog = document.querySelector('.gwb-modal__dialog');
    if (gwbDialog) {
    var gwbF = gwbDialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (gwbF.length) {
    var gwbFirst = gwbF[0];
    var gwbLast = gwbF[gwbF.length - 1];
    if (event.shiftKey && document.activeElement === gwbFirst) { event.preventDefault(); gwbLast.focus(); }
    else if (!event.shiftKey && document.activeElement === gwbLast) { event.preventDefault(); gwbFirst.focus(); }
    }
    }
    return;
    }
    if (modal.hidden && document.activeElement && document.activeElement.classList && document.activeElement.classList.contains('gwb__frame-slot')) {
    var gwbArrows = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
    var gwbDir = gwbArrows[event.key];
    if (gwbDir) {
    event.preventDefault();
    var gwbSlotId = document.activeElement.getAttribute('data-slot');
    var gwbSlot = getSlotById(gwbSlotId);
    if (gwbSlot) {
    var gwbStep = event.shiftKey ? 5 : 1;
    var gwbC = getSlotCenter(gwbSlot);
    setSlotCenter(gwbSlot, gwbC.x + gwbDir[0] * gwbStep, gwbC.y + gwbDir[1] * gwbStep);
    saveState();
    renderAll();
    var gwbRe = document.querySelector('.gwb__frame-slot[data-slot="' + gwbSlotId + '"]');
    if (gwbRe) gwbRe.focus();
    }}}
  });
 
  restoredState = loadState();
  if (restoredState) {
    applyRestoredStateBasic(restoredState);
  } else {
    preserveSlots(state.count);
  }
  applyStageRatio(DECORS[state.activeScene].ratio);
  root.querySelectorAll('[data-scene]').forEach(function(btn) {
    var active = btn.getAttribute('data-scene') === state.activeScene;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  root.querySelectorAll('[data-count]').forEach(function(btn) {
    var active = Number(btn.getAttribute('data-count')) === state.count;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  root.querySelectorAll('[data-preset]').forEach(function(btn) {
    var active = btn.getAttribute('data-preset') === state.activePreset;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  root.querySelectorAll('[data-spacing]').forEach(function(btn) {
    var active = btn.getAttribute('data-spacing') === state.spacingMode;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
 
  if (restoredState && restoredState.customPhoto && restoredState.customPhoto.enabled && restoredState.customPhoto.src) {
    state.customPhoto.enabled = true;
    state.customPhoto.src = restoredState.customPhoto.src;
    state.customPhoto.x = Number(restoredState.customPhoto.x || 0);
    state.customPhoto.y = Number(restoredState.customPhoto.y || 0);
    state.customPhoto.naturalWidth = Number(restoredState.customPhoto.naturalWidth || 0);
    state.customPhoto.naturalHeight = Number(restoredState.customPhoto.naturalHeight || 0);
    customPhotoImage.src = restoredState.customPhoto.src;
    customPhotoLayer.hidden = false;
    photoRemove.hidden = false;
    if (photoPositionControls) photoPositionControls.hidden = false;
    if (state.customPhoto.naturalWidth && state.customPhoto.naturalHeight) {
      applyStageRatio(state.customPhoto.naturalWidth / state.customPhoto.naturalHeight);
      fitCustomPhoto();
    }
  }
 
  state.mobileDrawerOpen = false;
  state.mobileFocusSlotId = null;
  renderAll();
  fetchProducts();
 
  saveState();
})();